import type { StorefrontBlogPost } from '../lib/dropify'
import { AdNewsProofSection } from './HomeNewsSection'

const STEPS = [
  { number: '01', title: 'Kirim detail produk', desc: 'Sebutkan varian, jumlah beserta satuannya, dan kota tujuan.' },
  { number: '02', title: 'Terima penawaran', desc: 'Admin mengirim foto stok aktual, harga, ongkir, dan estimasi pengiriman.' },
  { number: '03', title: 'Setujui dan bayar', desc: 'Admin akan memproses pesanan setelah mengonfirmasi pembayaran Anda.' },
]

export function BrandEasyOrder({
  newsPosts,
  showNewsProof = true,
}: {
  newsPosts?: StorefrontBlogPost[]
  showNewsProof?: boolean
} = {}) {
  return (
    <>
      <section id="pesan-tanpa-ribet" className="scroll-mt-6 border-y border-emerald-100 bg-emerald-50 py-10 md:py-12">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 lg:grid-cols-[0.8fr_1.2fr] lg:items-center">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.22em] text-emerald-700">Cara order grosir</p>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-slate-950 md:text-3xl">
              Pesan grosir via WhatsApp. Satu admin menangani proses dari cek stok sampai pengiriman
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600 md:text-base">
              Cukup kirim detail produk, jumlah, dan kota tujuan lewat WhatsApp. Satu admin mengecek stok, menghitung harga dan ongkir, mengonfirmasi pembayaran, lalu mengatur pengiriman. Kami memproses pesanan dari Surabaya dan dapat mengirimnya ke seluruh Indonesia.
            </p>
          </div>

          <ol className="grid gap-3 sm:grid-cols-3">
            {STEPS.map((step) => (
              <li key={step.number} className="rounded-2xl border border-emerald-100 bg-white p-4 shadow-sm">
                <span className="text-xs font-black text-emerald-700">{step.number}</span>
                <h3 className="mt-2 text-sm font-black text-slate-950">{step.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-slate-600">{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {showNewsProof && <AdNewsProofSection posts={newsPosts} />}
    </>
  )
}
